import { render } from "./PaperSlogan.vue?vue&type=template&id=45990979&scoped=true"
import script from "./PaperSlogan.vue?vue&type=script&lang=js"
export * from "./PaperSlogan.vue?vue&type=script&lang=js"

import "./PaperSlogan.vue?vue&type=style&index=0&id=45990979&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45990979"]])

export default __exports__